module.exports = __webpack_public_path__ + "static/img/duijiang2.3fae1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duijiang2.png
// module id = flhb
// module chunks = 24